import React from 'react';

import { CardStateCell } from '../my-cards-state-cell';
import { Card } from '../../../../models';
import { DateCell } from '../../../../components/table/table-cells/table-date-cell';
import { DateTimeCell } from '../../../../components/table/table-cells/table-date-time-cell';
import { typeOfHolderMapping } from '../my-cards-type-of-holder-cell';
import { FormattedMessage } from 'react-intl';

type DetailItemsType = {
  label: string;
  render: (data: Card) => JSX.Element | string;
}[];

function sanitizeRenderedData(data: any) {
  if (data == null) {
    return '-';
  } else return data.toString();
}

export const DetailItems: DetailItemsType = [
  {
    label: 'VPUK__MY_CARDS__FULLNAME',
    render: ({ fullName }) => `${fullName}`,
  },
  {
    label: 'VPUK__MY_CARDS__CARD_STATE',
    render: function CardStateItem(card) {
      return <CardStateCell data={card.cardState} allData={card} />;
    },
  },
  {
    label: 'VPUK__MY_CARDS__TYPE_OF_HOLDER',
    render: function CardTypeOfHolder(card) {
      return (
        <FormattedMessage
          id={
            typeOfHolderMapping[card.typeOfHolder] ??
            'VPUK__MY_CARDS__TYPE_OF_HOLDER__UNKNOWN'
          }
        />
      );
    },
  },
  {
    label: 'VPUK__MY_CARDS__CARD_VALID_FROM',
    render: function CardValidFrom({ cardValidFrom }) {
      return <DateCell data={(cardValidFrom as unknown) as string} />;
    },
  },
  {
    label: 'VPUK__MY_CARDS__CARD_LAST_CHANGE',
    render: function LastChange({ cardLastChange }) {
      return <DateTimeCell data={(cardLastChange as unknown) as string} />;
    },
  },
  {
    label: 'VPUK__MY_CARDS__LICENCE_VALID_TO',
    render: function LastLicence({ licenceValidTo }) {
      return <DateCell data={(licenceValidTo as unknown) as string} />;
    },
  },
  {
    label: 'VPUK__MY_CARDS__LICENCE_NUMBER',
    render: ({ licenceNumber }) => sanitizeRenderedData(licenceNumber),
  },
  {
    label: 'VPUK__MY_CARDS__LICENCE_LAST_CHANGE',
    render: function LastLicenceChange({ licenceLastChange }) {
      return <DateTimeCell data={(licenceLastChange as unknown) as string} />;
    },
  },
];
